import { render, staticRenderFns } from "./ExpenseItemColumnWizard.vue?vue&type=template&id=479d4473&"
import script from "./ExpenseItemColumnWizard.vue?vue&type=script&lang=js&"
export * from "./ExpenseItemColumnWizard.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseItemColumnWizard.vue?vue&type=style&index=0&id=479d4473&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports